import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dispatch-modal tw-bg-transparent tw-shadow-none tw-border-0 tw-rounded-none tw-overflow-hidden" }
const _hoisted_2 = { class: "tw-border-b tw-border-slate-200/70 tw-px-4 tw-py-4 sm:tw-px-5" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-justify-between" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-gap-2" }
const _hoisted_5 = { class: "tw-border-b tw-border-slate-200/70 tw-bg-white/80 tw-px-4 tw-py-4 sm:tw-px-5" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-start sm:tw-justify-between" }
const _hoisted_7 = { class: "tw-min-w-0" }
const _hoisted_8 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_9 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-amber-500/15 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-amber-800"
}
const _hoisted_10 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-md tw-bg-indigo-500/15 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-indigo-800"
}
const _hoisted_11 = { class: "tw-text-sm tw-font-medium tw-text-slate-700" }
const _hoisted_12 = { class: "tw-mt-3 tw-w-full tw-overflow-x-auto" }
const _hoisted_13 = { class: "tw-inline-flex tw-min-w-max tw-items-stretch tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-shadow-sm tw-shadow-slate-900/5 tw-divide-x tw-divide-slate-200/70" }
const _hoisted_14 = { class: "tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2" }
const _hoisted_15 = { class: "tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2" }
const _hoisted_16 = { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }
const _hoisted_17 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2"
}
const _hoisted_18 = { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }
const _hoisted_19 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2"
}
const _hoisted_20 = { class: "tw-text-sm tw-font-semibold tw-text-slate-900" }
const _hoisted_21 = { class: "tw-mt-3 tw-flex tw-flex-wrap tw-items-end tw-gap-x-4 tw-gap-y-1" }
const _hoisted_22 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-text-sm tw-text-slate-600" }
const _hoisted_23 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-slate-700"
}
const _hoisted_24 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-text-slate-700"
}
const _hoisted_25 = {
  key: 0,
  class: "tw-mt-4"
}
const _hoisted_26 = { class: "tw-relative tw-mt-2" }
const _hoisted_27 = { class: "tw-relative tw-h-6" }
const _hoisted_28 = { class: "tw-absolute tw-inset-x-0 tw-top-1/2 tw-flex tw--translate-y-1/2 tw-items-center tw-justify-between" }
const _hoisted_29 = ["title"]
const _hoisted_30 = { class: "tw-mt-2 tw-flex tw-items-start tw-justify-between tw-gap-2" }
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "tw-p-4 sm:tw-p-5" }
const _hoisted_33 = { class: "uk-switcher switcher-container uk-margin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_ContainerTripsTable = _resolveComponent("ContainerTripsTable")!
  const _component_DispatchOrderCard = _resolveComponent("DispatchOrderCard")!
  const _component_DispatchContainerInfo = _resolveComponent("DispatchContainerInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$apollo.queries.container.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "circle-notch",
                  spin: "",
                  class: "tw-h-4 tw-w-4 tw-text-slate-500"
                }),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "tw-text-sm tw-font-semibold tw-text-slate-700" }, "Loading container…", -1))
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "tw-h-9 tw-w-9 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-slate-50" }, null, -1))
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tw-mt-3 tw-h-3 tw-w-40 tw-rounded tw-bg-slate-100" }, null, -1))
          ]),
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"tw-p-4 sm:tw-p-5\" data-v-7e8168cd><div class=\"tw-animate-pulse tw-space-y-4\" data-v-7e8168cd><div class=\"tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3\" data-v-7e8168cd><div class=\"tw-h-20 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60\" data-v-7e8168cd></div><div class=\"tw-h-20 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60\" data-v-7e8168cd></div><div class=\"tw-h-20 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60\" data-v-7e8168cd></div></div><div class=\"tw-h-10 tw-rounded-xl tw-bg-slate-100\" data-v-7e8168cd></div><div class=\"tw-rounded-2xl tw-border tw-border-slate-200/70 tw-overflow-hidden\" data-v-7e8168cd><div class=\"tw-h-10 tw-bg-slate-50\" data-v-7e8168cd></div><div class=\"tw-space-y-0\" data-v-7e8168cd><div class=\"tw-h-10 tw-bg-white\" data-v-7e8168cd></div><div class=\"tw-h-10 tw-bg-slate-50/50\" data-v-7e8168cd></div><div class=\"tw-h-10 tw-bg-white\" data-v-7e8168cd></div></div></div></div></div>", 1))
        ], 64))
      : (_ctx.container)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.container.order && _ctx.container.order.isExport)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Export"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "Import")),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.container.size) + _toDisplayString(_ctx.container.type), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Order", -1)),
                        (_ctx.container.order)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "tw-text-sm tw-font-semibold tw-text-slate-900 hover:tw-underline",
                              to: '/orders/' + _ctx.container.order.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("#" + _toDisplayString(_ctx.container.order.id), 1)
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true),
                        (_ctx.container.order)
                          ? (_openBlock(), _createBlock(_component_CopyButton, {
                              key: 1,
                              value: String(_ctx.container.order.id),
                              title: "Copy order #",
                              "aria-label": "Copy order number"
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Container", -1)),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.container.containerId !== 'EXPUNDEF' ? _ctx.container.containerId : 'Unknown'), 1),
                        (_ctx.container.containerId && _ctx.container.containerId !== 'EXPUNDEF')
                          ? (_openBlock(), _createBlock(_component_CopyButton, {
                              key: 0,
                              value: String(_ctx.container.containerId),
                              title: "Copy container #",
                              "aria-label": "Copy container number"
                            }, null, 8, ["value"]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.container.order && _ctx.container.order.isExport)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, "Booking", -1)),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.container.order.bookingNumber || '—'), 1),
                            (_ctx.container.order.bookingNumber)
                              ? (_openBlock(), _createBlock(_component_CopyButton, {
                                  key: 0,
                                  value: String(_ctx.container.order.bookingNumber),
                                  title: "Copy booking #",
                                  "aria-label": "Copy booking number"
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.container.order && _ctx.container.order.billOfLading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-500" }, "BL", -1)),
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.container.order.billOfLading.billOfLadingId), 1),
                              (_ctx.container.order.billOfLading.billOfLadingId)
                                ? (_openBlock(), _createBlock(_component_CopyButton, {
                                    key: 0,
                                    value: String(_ctx.container.order.billOfLading.billOfLadingId),
                                    title: "Copy bill of lading",
                                    "aria-label": "Copy bill of lading"
                                  }, null, 8, ["value"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      (_ctx.container.terminalAppointmentDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Term Apt: " + _toDisplayString(_ctx.formatAppointmentDatetime(_ctx.container.terminalAppointmentDate, _ctx.container.terminalAppointmentHasTime)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.container.deliveryAppointmentDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Del Apt: " + _toDisplayString(_ctx.formatAppointmentDatetime(_ctx.container.deliveryAppointmentDate, _ctx.container.deliveryAppointmentHasTime)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (_ctx.tripStops.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "tw-absolute tw-left-0 tw-right-0 tw-top-1/2 tw-h-1 tw--translate-y-1/2 tw-rounded-full tw-bg-slate-200" }, null, -1)),
                        _createElementVNode("div", {
                          class: "tw-absolute tw-left-0 tw-top-1/2 tw-h-1 tw--translate-y-1/2 tw-rounded-full tw-bg-emerald-500",
                          style: _normalizeStyle({ width: _ctx.tripProgressPercent + '%' })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tripStops, (stop, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `stop-dot-${idx}`,
                              class: "tw-flex tw-items-center tw-justify-center",
                              title: stop
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["tw-relative tw-z-10 tw-h-3.5 tw-w-3.5 tw-rounded-full tw-border tw-bg-white", idx <= _ctx.tripProgressStopIndex
                      ? 'tw-border-emerald-500 tw-bg-emerald-500'
                      : 'tw-border-slate-300'])
                              }, null, 2)
                            ], 8, _hoisted_29))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tripStops, (stop, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `stop-label-${idx}`,
                            class: "tw-w-20 tw-text-center tw-text-[11px] tw-leading-tight tw-text-slate-500 tw-truncate",
                            title: stop
                          }, _toDisplayString(stop), 9, _hoisted_31))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "tw-flex tw-justify-center" }, [
                _createElementVNode("ul", {
                  class: "uk-subnav uk-subnav-pill uk-margin-remove-bottom dispatch-modal__tabs",
                  "uk-switcher": "connect: .switcher-container"
                }, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "" }, " Trips ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "" }, "Order")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", { href: "" }, "Containers")
                  ])
                ])
              ], -1)),
              _createElementVNode("ul", _hoisted_33, [
                _createElementVNode("li", null, [
                  _createVNode(_component_ContainerTripsTable, {
                    caller: "dispatch",
                    order: _ctx.container.order,
                    container: _ctx.container,
                    trips: _ctx.container.trips,
                    drivers: _ctx.drivers,
                    chassis: _ctx.filteredChassis,
                    editable: !_ctx.container.isCancelled,
                    onRefreshOrders: _ctx.emitDispatchRefresh
                  }, null, 8, ["order", "container", "trips", "drivers", "chassis", "editable", "onRefreshOrders"])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_DispatchOrderCard, {
                      orderId: Number(_ctx.container.order.id)
                    }, null, 8, ["orderId"])
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_DispatchContainerInfo, { container: _ctx.container }, null, 8, ["container"])
                  ])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}